// extracted by mini-css-extract-plugin
export default {"ldsRing":"loader_ldsRing__BrpIK"};